import React from 'react';
import './Card.css';

const Card = ({ children, title = null }) => {
  return (
    <div className="card">
      {title && (
        <>
          <h2 className="card__title">{title}</h2>
          <div className="card__separator" />
        </>
      )}
      <div className="card__content">{children}</div>
    </div>
  );
};

export default Card;
